module.exports = __webpack_public_path__ + "static/media/map4.b5ccd8f1.gif";